import { useCallback, useState } from 'react';

export const useInputEvent = setState =>
  useCallback(({ target: { value } }) => setState(value), [setState]);

export const useUpdatedState = (initial, key) => {
  let fromStorage;
  try {
    const valueFromStorage = localStorage.getItem(key);
    if (valueFromStorage) fromStorage = JSON.parse(valueFromStorage);
  } catch (e) {
    // no storage;
  }
  const initialValue =
    fromStorage === null || fromStorage === undefined ? initial : fromStorage;
  const [state, setState] = useState(initialValue);

  const updateState = useCallback(
    newValue => {
      setState(oldValue => {
        const setValue =
          typeof newValue === 'function' ? newValue(oldValue) : newValue;
        try {
          if (key) localStorage.setItem(key, JSON.stringify(setValue));
        } catch (e) {
          // no storage;
        }
        return setValue;
      });
    },
    [key, setState],
  );
  return [state, updateState];
};

export const useInputState = (initial, key) => {
  const [state, setState] = useUpdatedState(initial, key);
  const updateState = useInputEvent(setState);
  return [state, updateState, setState];
};

export const useIntegerEvent = (setState, min?: number, max?: number) =>
  useCallback(
    ({ target: { value } }) => {
      let newValue = value ? parseInt(value, 10) : 0;
      if (min != null && newValue < min) newValue = min;
      if (max != null && newValue > max) newValue = max;
      setState(newValue);
    },
    [setState, min, max],
  );

export const useIntegerState = (initial, key, min?: number, max?: number) => {
  const [state, setState] = useUpdatedState(initial, key);
  const updateState = useIntegerEvent(setState, min, max);
  return [state, updateState, setState];
};

export const useFloatEvent = (setState, min?: number, max?: number) =>
  useCallback(
    ({ target: { value } }) => {
      let newValue = value ? parseFloat(value) : 0;
      if (min != null && newValue < min) newValue = min;
      if (max != null && newValue > max) newValue = max;
      setState(newValue);
    },
    [max, min, setState],
  );

export const useFloatState = (initial, key, min?: number, max?: number) => {
  const [state, setState] = useUpdatedState(initial, key);
  const updateState = useFloatEvent(setState, min, max);
  return [state, updateState, setState];
};

export const useCheckboxEvent = setState =>
  useCallback(({ target: { checked } }) => setState(checked), [setState]);

export const useCheckboxState = (initial, key) => {
  const [state, setState] = useUpdatedState(initial, key);
  const updateState = useCheckboxEvent(setState);
  return [state, updateState, setState];
};
